import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/site/Header';
import Footer from '../../components/site/Footer';
import ContactMain from './ContactMain';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    if (scrollTop > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <React.Fragment>
      <Header />
      <main>
        <ContactMain />
      </main>
      <BackToTop scroll={isVisible} />
      <Footer />
    </React.Fragment>
  );
};

export default Contact;
